// src/pages/Signup.jsx
import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import { useNavigate } from 'react-router-dom';
import './Signup.css';

function Signup() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    setError(null);

    if (password !== confirmPassword) {
      setError('비밀번호가 일치하지 않습니다.');
      return;
    }

    const { data, error } = await supabase.auth.signUp({ email, password });
    console.log('회원가입 결과:', { data, error });

    if (error) {
      if (error.message === 'User already registered') {
        setError('이미 가입된 이메일입니다.');
      } else {
        setError('회원가입 중 오류가 발생했습니다: ' + error.message);
      }
    } else {
      setShowModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    navigate('/login');
  };

  return (
    <div className="login-container">
      <h2 className="login-title">Sign Up</h2>
      <form className="login-form" onSubmit={handleSignup}>
        <input
          type="email"
          placeholder="Email"
          className="login-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <div className="password-wrapper">
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder="Password"
            className="login-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button
            type="button"
            className="toggle-btn"
            onClick={() => setShowPassword((prev) => !prev)}
          >
            {showPassword ? '🙈' : '🐵'}
          </button>
        </div>

        <div className="password-wrapper">
          <input
            type={showConfirm ? 'text' : 'password'}
            placeholder="Confirm Password"
            className="login-input"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
          <button
            type="button"
            className="toggle-btn"
            onClick={() => setShowConfirm((prev) => !prev)}
          >
            {showConfirm ? '🙈' : '🐵'}
          </button>
        </div>

        {error && <p className="login-error">{error}</p>}

        <button type="submit" className="login-button">
          회원가입
        </button>
      </form>

      {showModal && (
        <div className="modal-backdrop">
          <div className="modal">
            <h3>회원가입 완료 🎉</h3>
            <p>
              입력하신 이메일 주소로 인증 메일이 전송되었습니다.
              <br />
              <strong>메일함을 열고 인증 링크를 클릭하셔야 로그인할 수 있습니다.</strong>
            </p>
            <button className="modal-btn" onClick={handleCloseModal}>
              확인
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Signup;
